module.exports = __webpack_public_path__ + "static/media/phone.ff89a9fc.png";